import { useState } from 'react';
import { getLocalTimeZone, now, ZonedDateTime } from '@internationalized/date';
import { truncateToMinutes } from '@/utils/helpers';

const getEstimatedOr = () => {
  const timeZone = getLocalTimeZone();
  const minOrDateTime = now(timeZone).add({ hours: 6 });
  return truncateToMinutes(minOrDateTime);
};

export const useOrDateTimeState = (orCaseDateTime?: ZonedDateTime | null) => {
  const [orTimeCustom, setOrTimeCustom] = useState(getEstimatedOr);
  const [isCustomOr, setIsCustomOr] = useState(false);
  const orDateTime = orCaseDateTime ?? orTimeCustom;
  const showOrTypeSwitch = !orCaseDateTime;

  const toggleOrType = (value: boolean) => {
    setIsCustomOr(value);
    setOrTimeCustom(getEstimatedOr());
  };

  return {
    orDateTime,
    showOrTypeSwitch,
    isCustomOr,
    setIsCustomOr: toggleOrType,
    setOrTimeCustom,
  };
};
